<style lang="postcss">
	.nps-label {
		cursor: pointer;
		display: flex;
		justify-content: center;
		height: 2.8rem;
		width: 2.8rem;
		padding: 0 0.375rem 0.375rem 0;
	}
	.nps-option {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		opacity: 0.75;
		border-radius: 2.5px;
	}
	.nps-option.active,
	.nps-option:hover {
		opacity: 1;
	}
	.nps-option > input {
		position: absolute;
		opacity: 0;
		z-index: -1;
	}
	.nps-label:hover .nps-number {
		opacity: 1;
	}
	.nps-number {
		font-size: 0.8rem;
	}
	@container (min-width: 20rem) {
		.nps-label {
			height: 2rem;
			padding: 0;
		}
	}
	@container (min-width: 24rem) {
		.nps-label {
			flex: 1 1 0%;
			height: auto;
			aspect-ratio: 1 / 1;
		}
	}
	@container (min-width: 28rem) {
		.nps-number {
			font-size: 0.95rem;
		}
	}
	@container (max-width: 20rem) {
		.nps-label {
			font-weight: 500;
			height: auto;
			width: auto;
			aspect-ratio: 1 / 1;
			flex: 1;
			padding: 0 0.25rem 0.25rem 0;
		}
		.nps-number {
			font-size: 0.8rem;
		}
	}
</style>

<script lang="ts">
	export let disabled: boolean = false;
	export let name: string;
	export let number: number;
	export let value: string = undefined;
	$: type = number < 7 ? "detractor" : number < 9 ? "passive" : "promoter";
	$: active = typeof value !== "undefined" && value === number.toString();
</script>

<label class="nps-label group">
	<div
		class:active="{active}"
		class:disabled="{disabled}"
		class="{type} nps-option">
		{#if disabled === false}
			<input
				bind:group="{value}"
				type="radio"
				name="{name}"
				value="{number.toString()}" />
		{/if}
		<div class="nps-number all-center">
			{number}
		</div>
	</div>
</label>
